export const inputStyle =
  "rounded-md border border-light-gray py-2 px-4 font-inter text-sm";

export const buttonStyle = "text-xs font-inter py-3 rounded-md bg-main-black text-main-white hover:bg-light-black"